export default "__VITE_ASSET__v8Q2SN2h__"